import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const NewWebhookTemplate = lazy(() =>
  import("@scenes/MessageComposition/Webhook/WebhookTemplates/WebhookTemplateLibrary/NewWebhookTemplate").then(
    (module) => ({
      default: module.NewWebhookTemplate,
    })
  )
);

export const engagementTemplatesAndMediaWebhookTemplatesNewNRO: NavigationRoutingObject = {
  Component: NewWebhookTemplate,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-webhook-templates-new-nro-heading", "New Webhook Template"),
  pageNameForTracking: () => "New Webhook Template",
  icon: "nav-system-webhook-dashed",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    if (!featureOn("webhook")) {
      return false;
    }
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "editWebhookTemplates" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
